import { render, staticRenderFns } from "./SettingsSms.vue?vue&type=template&id=8848e32e"
import script from "./SettingsSms.vue?vue&type=script&lang=js"
export * from "./SettingsSms.vue?vue&type=script&lang=js"
import style0 from "./SettingsSms.vue?vue&type=style&index=0&id=8848e32e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports